import { styled } from '@innowise-group/mui-kit';

export const LabelAndValueWrapper = styled.div``;
export const OptionWrapper = styled.div``;
export const Label = styled.span``;
export const Value = styled.span`
  ${({ theme }) => theme.fonts.primary[30]}
`;
